import api from '@/utils/axios';

function assertSuccess(response, fallbackMessage) {
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || fallbackMessage);
  }
  return response.data;
}

export async function fetchHistoryList({ filter = {}, limit = 500 } = {}) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('history/list', { token, filter, limit });
  const data = assertSuccess(response, 'Failed to load history');
  return {
    data: data.data || {},
    meta: data.meta || {}
  };
}

export async function fetchHistoryGrouped({ filter = {}, limit = 100 } = {}) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('history/grouped', { token, filter, limit });
  const data = assertSuccess(response, 'Failed to load history timeline');
  return {
    data: data.data || {},
    meta: data.meta || {}
  };
}
